<template>
  <figure class="highcharts-figure">
    <highcharts ref="chart" :options="options" />
    <p class="highcharts-description highcharts-linked-description">
      <strong>Figure : </strong>
      <span v-html="$t('compGraphicsMealsEmissionFactors.help')" />
    </p>
  </figure>
</template>

<script>
import '@/plugins/highcharts.js'
import FOOD_FACTORS from '@/../data/factors/carbon/foodFactors.json'

export default {
  name: 'MealsEmissionFactors',
  props: {
    ghgi: {
      type: Object,
      default: null
    }
  },
  computed: {
    series: function () {
      let data = []
      for (let meal of Object.keys(FOOD_FACTORS)) {
        data.push({
          name: this.$t(meal),
          y: FOOD_FACTORS[meal].decomposition['2021'].total.total
        })
      }
      return [
        {
          name: '',
          showInLegend: false,
          data: data
        }
      ]
    },
    categories: function () {
      return Object.keys(FOOD_FACTORS).map((val) => this.$t(val))
    },
    options: function () {
      let self = this
      return {
        chart: {
          type: 'column'
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: this.categories
        },
        yAxis: {
          min: 0,
          title: {
            text: this.$t('kg.co2e.meal')
          },
          stackLabels: {
            enabled: true,
            formatter () {
              return `${this.total.toFixed(2)}`
            }
          }
        },
        tooltip: {
          formatter: function () {
            let tooltip = this.points[0].x + ' <br />'
            for (let i in this.points) {
              tooltip +=
                this.points[i].series.name +
                '<b>' +
                Math.round(this.points[i].y * 100) / 100
              tooltip += '</b> ' + self.$t('kg.co2e.meal')
            }
            return tooltip
          },
          shared: true
        },
        exporting: {
          enabled: false
        },
        series: this.series
      }
    }
  }
}
</script>

<style scoped>
.highcharts-figure {
  min-width: 320px;
  max-width: 700px;
  margin: 1em auto;
}
.highcharts-description {
  text-align: center;
  color: '#777777';
  font-style: italic;
}
</style>
